@if (!sidebarItems.length) {
  <div class="py-3 text-center" style="margin-top: 50px">
    <p>{{ 'platform.noStudies' | translate }}</p>
    <p>Please try to sign in again. If the problem persists, contact your administrator.</p>
  </div>
}
@if (showLoginButton) {
  <div class="d-flex justify-content-center">
    <button class="btn btn-sm btn-primary text-center" (click)="logout()">
      {{ 'platform.login.back-to-sign-in' | translate }}
    </button>
  </div>
}
